export default class ApplicationError extends Error {
    toJSON() {
        const keys = Object.keys(this);
        const unsafeThis = this;
        const sentryData = {};
        keys.forEach(key => {
            let keyValue = unsafeThis[key];
            if (keyValue instanceof Error && !(keyValue instanceof ApplicationError)) {
                keyValue = keyValue.toString();
            }
            if (keyValue instanceof ApplicationError) {
                keyValue = keyValue.toJSON();
            }
            sentryData[key] = keyValue;
        });
        return sentryData;
    }
}
